import client from './client';

export const organisationsApi = {
  me: () => client.get('/organisations/me/').then((r) => r.data),
  onboard: (data) => client.post('/organisations/onboard/', data).then((r) => r.data),
  updateMe: (data) => client.patch('/organisations/me/update/', data).then((r) => r.data),

  listCrops: () => client.get('/organisations/crops/').then((r) => r.data),

  listFarmers: () => client.get('/organisations/farmers/').then((r) => r.data),
  createFarmer: (data) => client.post('/organisations/farmers/', data).then((r) => r.data),
  updateFarmer: (id, data) => client.patch(`/organisations/farmers/${id}/`, data).then((r) => r.data),
  deleteFarmer: (id) => client.delete(`/organisations/farmers/${id}/`),

  listFarms: () => client.get('/organisations/farms/').then((r) => r.data),
  createFarm: (data) => client.post('/organisations/farms/', data).then((r) => r.data),
  updateFarm: (id, data) => client.patch(`/organisations/farms/${id}/`, data).then((r) => r.data),
  deleteFarm: (id) => client.delete(`/organisations/farms/${id}/`),
};
